import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { OutlookAuthService } from '../outlook-auth.service';

@Component({
  selector: 'app-refresh-token-lp',
  templateUrl: './refresh-token-lp.component.html',
  styleUrls: ['./refresh-token-lp.component.css']
})
export class RefreshTokenLpComponent implements OnInit {
  urlParams = null;
  auth_code: string = null;
  refresh_token: string = null;
  tokenNotified = false;
  origin: string;
  tokenError = false;
  constructor(
    private route: ActivatedRoute,
    private outlookService: OutlookAuthService
  ) {
    this.outlookService.tokenError.subscribe(
      param => {
        if(!!param) {
          this.outlookService.notifyTokenError(this.origin, param.error).subscribe(
            () => this.tokenError = true
          )
        }
      }
    )
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(
      params => {
        if(Object.entries(params).length > 0 && params["refresh_token"]) {
          this.auth_code = params["refresh_token"];
          this.origin = params["redirect_uri"];
          this.refreshToken(params["refresh_token"], params);
        }
      }
    )
  }

  private refreshToken(refresh_token: string, params: Params) {
    this.outlookService.refreshAccessToken(refresh_token, params).subscribe(
      res => {
        this.refresh_token = res.refresh_token;
        this.notify(res, params);
      }
    );
  }

  notify(payload, params) {
    // let body = {auth: [payload]}; /// mock only
    let urlOrigin = params["redirect_uri"];
    this.origin = params["redirect_uri"];
    this.outlookService.notifyTokenObtained(urlOrigin, payload).subscribe(
      () => {
        this.tokenNotified = true;
      }
    )
  }
}
